/**
 * @fileoverview added by tsickle
 * Generated from: util/shims.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Shim the String.prototype.includes() method.
 * @return {?}
 */
export function stringIncludes() {
    if (!String.prototype.includes) {
        String.prototype.includes = (/**
         * @param {?} search
         * @return {?}
         */
        function (search) {
            return this.indexOf(search) !== -1;
        });
    }
}
